import { useEffect, useState } from "react";
import { api, formatEUR, formatDateTime } from "@/lib/api";
import { DashboardShell } from "@/components/Shell";
import { Inbox, MessageCircle } from "lucide-react";

export default function StaffInbox() {
  const [items, setItems] = useState([]);

  useEffect(() => { api.get("/staff/me/inbox").then((r) => setItems(r.data)); }, []);

  return (
    <DashboardShell role="staff">
      <div className="mb-8">
        <div className="text-xs tracking-[0.25em] uppercase text-[#EBB300]">Nachrichten</div>
        <h1 className="text-4xl md:text-5xl font-black tracking-tight mt-2 flex items-center gap-3">
          <Inbox className="w-9 h-9 text-[#EBB300]" /> Posteingang
        </h1>
        <p className="text-[#A1A1AA] mt-2">Feedback und Nachrichten deiner Gäste.</p>
      </div>

      {items.length === 0 ? (
        <div className="bg-[#121216] border border-dashed border-white/10 rounded-2xl p-12 text-center" data-testid="staff-inbox-empty">
          <MessageCircle className="w-10 h-10 text-[#52525B] mx-auto mb-4" />
          <p className="text-[#A1A1AA]">Noch keine Nachrichten — sobald ein Gast dir eine schickt, erscheint sie hier.</p>
        </div>
      ) : (
        <div className="grid md:grid-cols-2 gap-4" data-testid="staff-inbox-list">
          {items.map((m) => (
            <div key={m.id} className="bg-[#121216] border border-white/5 rounded-2xl p-5">
              <div className="flex items-baseline justify-between mb-3">
                <div className="font-bold">{m.customer_name || "Anonym"}</div>
                <div className="text-lg font-black text-[#EBB300]">{formatEUR(m.amount)}</div>
              </div>
              <p className="text-sm text-white/90 italic leading-relaxed">„{m.message}"</p>
              <div className="text-xs text-[#A1A1AA] mt-4 flex justify-between">
                <span>{m.location_name || "Direkt"}</span>
                <span>{formatDateTime(m.created_at)}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </DashboardShell>
  );
}
